import axios from 'axios'
import {
  host
} from './base.api.js'

var url = {
  base: host + '/SocialAgent/Account/base',
  userInfo: '/api/socialagent/user/info',
  sendcaptcha: host + '/api/socialagent/user/sendcaptcha',
  login: host + '/api/socialagent/user/login',
  logout: host + '/api/socialagent/user/logout',
  certificateInfo: host + '/api/socialagent/user/certificate/info',
  certificateImages: host + '/api/socialagent/user/certificate/images',
  certificateSubmit: host + '/api/socialagent/user/certificate/submit',
  createImgCode: host + '/api/socialagent/user/createImgCode',
  createMobileCodeByImgCode: host + '/api/socialagent/user/createMobileCodeByImgCode',
  getUserBankInfo: host + '/api/socialagent/user/getUserBankInfo',
  getBankNo: host + '/api/socialagent/order/getBankInfo',
  getPayMoney: host + '/api/socialagent/order/getPayMoney',
  getPayMoneyList: host + '/api/socialagent/order/getPayMoneyList',
  getAlreadyMoneyList: host + '/api/socialagent/order/getAlreadyMoneyList',
  saveWithdrawMoney: host + '/api/socialagent/order/saveWithdrawMoney',
  saveComplement: host + '/api/socialagent/user/complement',
  getLocationByIp: 'https://autoapi.autohome.com.cn/th-hs-service/th-insure/innderForward/v2/clueCollect/getLocationInfo',
  getMiniLogin: host + '/api/mall/user/login',
}
export default {
  getUserInfo({
    pvareaId = 0
  }) {
    return axios.get(url.userInfo, {
      params: {
        pvareaId: pvareaId,
        t: new Date().getTime()
      }
    })
  },
  sendcaptcha({
    mobile = ''
  }) {
    var http = axios.post(url.sendcaptcha, {
      mobile: mobile
    })
    return http
  },
  login({
    mobile = '',
    messageCode = '',
    pvareaId = 0,
    complementUserName = '',
    complementAgentNo = ''
  }) {
    var http = axios.post(url.login, {
      mobile: mobile,
      messageCode: messageCode,
      pvareaId: pvareaId,
      complementUserName: complementUserName,
      complementAgentNo: complementAgentNo,
      t: new Date().getTime()
    })
    return http
  },
  saveComplement({
    pvareaId = 0,
    complementUserName = '',
    complementAgentNo = ''
  }) {
    var http = axios.post(url.saveComplement, {
      pvareaId: pvareaId,
      complementUserName: complementUserName,
      complementAgentNo: complementAgentNo,
      t: new Date().getTime()
    })
    return http
  },
  logout() {
    var http = axios.get(url.logout, {
      t: new Date().getTime()
    })
    window.sessionStorage.clear()
    window.localStorage.clear()
    return http
  },
  getCertificateInfo() {
    return axios.get(url.certificateInfo, {
      params: {}
    })
  },
  getCertificateImages({
    certificateId = 0
  }) {
    return axios.get(url.certificateImages, {
      params: {
        certificateId: certificateId,
        t: new Date().getTime()
      }
    })
  },
  certificateSubmit({
    certificateType = 0,
    images
  }) {
    return axios.post(url.certificateSubmit, {
      certificateType: certificateType,
      images: images,
      t: new Date().getTime()
    })
  },
  createImgCode({
    mobile = ''
  }) {
    return axios.post(url.createImgCode, {
      mobile,
      t: new Date().getTime()
    })
  },
  createMobileCodeByImgCode({
    mobile,
    imageCode
  }) {
    return axios.post(url.createMobileCodeByImgCode, {
      mobile,
      imageCode,
      t: new Date().getTime()
    })
  },
  getUserBankInfo() {
    return axios.get(url.getUserBankInfo, {
      params: {
        t: new Date().getTime()
      }
    })
  },
  /**
   * 银行卡信息接口
   * @param {string} PlatformAgentID
  */
  getBankData({ PlatformAgentID }) {
    var http = axios.post(url.getBankNo, {
      PlatformAgentID,
      t: new Date().getTime()
    })
    return http
  },
  /**
   * 代理人可提现金额
   * @param {string} PlatformAgentID
  */
  getPayMoneyData({ PlatformAgentID }) {
    var http = axios.post(url.getPayMoney + '?' + `PlatformAgentID=${PlatformAgentID}&t=${new Date().getTime()}`)
    return http
  },
  /**
   * 代理人可提现金额明细列表
   * @param {string} PlatformAgentID
  */
  getPayMoneyListData({ PlatformAgentID, pageNo, pageSize, dataType }) {
    var http = axios.post(url.getPayMoneyList + '?' + `PlatformAgentID=${PlatformAgentID}&pageNo=${pageNo}&pageSize=${pageSize}&DataType=${dataType}&t=${new Date().getTime()}`)
    return http
  },
  /**
   * 代理人已提现金额明细列表
   * @param {string} PlatformAgentID
   * @param {string} pageNo
   * @param {string} pageSize
   * @param {string} category  已提现/所有
  */
  getAlreadyMoneyListData({ PlatformAgentID, pageNo, pageSize, category }) {
    var http = axios.post(url.getAlreadyMoneyList + '?' + `PlatformAgentID=${PlatformAgentID}&pageNo=${pageNo}&pageSize=${pageSize}&category=${category}&t=${new Date().getTime()}`)
    return http
  },
  /**
   * 提现接口
   * @param {string} PlatformAgentID
   * @param {string} money   提现金额
   * @param {string} payType 提现方式
  */
  saveWithdrawMoneyData({ PlatformAgentID, money, payType }) {
    var http = axios.post(url.saveWithdrawMoney + '?' + `PlatformAgentID=${PlatformAgentID}&money=${money}&payType=${payType}&t=${new Date().getTime()}`)
    return http
  },
  /*
    * 根据ip获取定位城市
    */
  getCityByIp(ip) {
    var http = axios.get(url.getLocationByIp + `?ip=${ip}`)
    return http
  },
  /*
    * 小程序免登
    */
  getMiniLogin(data) {
    var http = axios.post(url.getMiniLogin, data)
    return http
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js